import React, {Component} from 'react'

import './index.css'

class About extends Component {
  render() {
    var email = 'contact@josieide.com'

    return (
      <section id={this.props.id}>
        <div className='container'>
          <h2>Contact</h2>
          <p>
            Josie is available for freelance or permanent facial reconstruction
            work.
          </p>
          <p>
            Please email the address below if you are interested in working with
            Josie.
          </p>
          <p>
            <a href={`mailto:${email}?Subject=Facial%20Reconstruction`} target='_blank'>{email}</a>
          </p>
        </div>
      </section>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/App/Contact/index.js